import { useCallback, useMemo } from 'react';
import { useLocalStorage } from '#src/hooks/storage.ts';

export const useDismissedMaintenances = () => {
  const [dismissedMaintenances, setDismissedMaintenances] = useLocalStorage<
    string[]
  >('dismissed-seek-api-maintenances', []);

  const maintenanceSet = useMemo(
    () => new Set(dismissedMaintenances),
    [dismissedMaintenances],
  );

  const dismissMaintenance = useCallback(
    (id: string) =>
      setDismissedMaintenances((prev) => {
        const next = new Set(prev);
        next.add(id);
        return Array.from(next);
      }),
    [setDismissedMaintenances],
  );

  return [maintenanceSet, dismissMaintenance] as const;
};
